import { generateId, getCurrentNumberId } from '#models/general/ids';
import { getSubStepValues } from '#models/general/steps';
import Input from '#components/general/Input';

import { SPIRIT_IDS_FIELDS, SPIRIT_SUBSTEPS_IDS } from './constants';

const generateMainSpiritId = (spiritNumber, week) => `S${spiritNumber} - ${week}`;

const generateSpiritId = generateId(generateMainSpiritId, 'spiritRunDateAndTime');

export const getSpiritIdsFields = ({ values, errors }) => {
  const getSpiritIdsValues = getSubStepValues(SPIRIT_SUBSTEPS_IDS.SPIRIT_IDS, values, errors);
  return [
    {
      ...getSpiritIdsValues(SPIRIT_IDS_FIELDS.SPIRIT_ID, false),
      Component: Input,
      disabled: true,
      value: generateSpiritId(values, getCurrentNumberId(values?.mashingId))
    }
  ];
};
